import * as Sentry from "@sentry/nextjs";
import moment from "moment-timezone";
import QueryString from "qs";

import {isBrowser} from "./isBrowser";
import monolith from "./fetch/fetches";
import {parseUtmParams} from "./parseUtmParams";
import {NextRequest} from "next/server";
import {getVisitId, getVisitorId} from "./visitData";
import {AnyNextRequest} from "./nextRequestType";
import {IncomingMessage, ServerResponse} from "http";

export const getVisitDataHeaders = (
  req?: AnyNextRequest,
  res?: ServerResponse<IncomingMessage>,
) => ({
  CarbonVisitId: getVisitId(req, res),
  CarbonVisitorId: getVisitorId(req, res),
});

export const visitTracking = async ({
  req,
}: {
  req: NextRequest;
}): Promise<{visitId: string; visitorId: string}> => {
  if (isBrowser()) throw new Error("Visit tracking is not allowed on client.");
  const query = QueryString.parse(req.url);

  const utm = parseUtmParams(query);
  const landingUrl = `${
    /carbonhealth\.com/gi.test(req.headers.get("host") || "") ? "https://" : ""
  }${req.headers.get("host")}${req.url}`;

  const headers = {
    ...(req.headers.get("referer") ? {Referer: req.headers.get("referer")} : {}),
  };

  try {
    const tracking = await monolith({allowedStatusCodes: [403]})("/hib/visit-tracking", {
      method: "POST",
      headers: {
        ...headers,
        ...getVisitDataHeaders(req),
      } as HeadersInit,
      body: JSON.stringify({utm, landingUrl, timezone: moment.tz.guess()}),
    });
    if (tracking.status == 403) {
      return {visitId: "", visitorId: ""};
    } else {
      const response = await tracking.json();
      return {visitId: response.visitId, visitorId: response.visitorId};
    }
  } catch (e) {
    const msg = `endpoint: /hib/visit-tracking . error: ${e}`;
    console.log(msg);
    Sentry.captureException(msg);
    return {visitId: "", visitorId: ""};
  }
};
